module.exports = __webpack_public_path__ + "static/media/humidity.1a19243c.svg";